import type { IncomingMessage } from "http";

import { env } from "./env";

export function getDeploymentUrl({ req }: { req?: IncomingMessage }): string {
  // Check if running on frontend
  if (typeof window !== "undefined") {
    // Frontend: Use the current window location
    return window.location.origin;
  }

  // Backend: Use the existing logic
  let url =
    env.NEXTAUTH_URL ??
    (env.VERCEL
      ? (req?.headers["x-forwarded-host"] as string) ??
        req?.headers.host ??
        env.VERCEL_URL ??
        env.NEXT_PUBLIC_VERCEL_URL
      : undefined);

  if (!url) {
    throw new Error("NEXTAUTH_URL or VERCEL_URL environment variable are not set");
  }

  // Remove trailing slash
  if (url.endsWith("/")) {
    url = url.slice(0, -1);
  }

  return url.startsWith("http") ? url : `https://${url}`;
}
